import { useTranslation } from "react-i18next";
import { Column, Row } from "@/ui-kit";
import { DatePickerControl, FileInputControl, InputControl } from "@/controls";

type IProps = {
  color?: "layer1" | "layer2";
};

export const HudForm = ({ color = "layer2" }: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <InputControl
        label={t("label.hud_id_number")}
        name="hudIdNumber"
        color={color}
      />

      <Row gap={16} alignmentVertical="top">
        <Column fullWidth>
          <DatePickerControl
            label={t("label.issuance_date")}
            name="hudIdIssuanceDate"
            maxDate={new Date()}
            color={color}
          />
        </Column>
        <Column fullWidth>
          <DatePickerControl
            label={t("label.expiry_date")}
            name="hudIdExpiryDate"
            minDate={new Date()}
            color={color}
          />
        </Column>
      </Row>

      <FileInputControl
        label={t("label.hud_front_image")}
        name="hudFrontPicture"
        variant={color}
      />

      <FileInputControl
        label={t("label.hud_back_image")}
        name="hudBackPicture"
        variant={color}
      />
    </>
  );
};
